import { render, staticRenderFns } from "./PointsContractWizard.vue?vue&type=template&id=184163d4&"
import script from "./PointsContractWizard.vue?vue&type=script&lang=js&"
export * from "./PointsContractWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports